.trigger {
  min-width: 0;
  cursor: pointer;
  border-radius: var(--ant-border-radius-sm);
}

.trigger:hover :global(.ant-typography) {
  color: var(--ant-color-primary);
}

.trigger:focus-visible {
  outline: var(--ant-line-width-focus) solid var(--ant-color-primary-border);
  outline-offset: 1px;
}
